var map = {
	"../courses/seller/course-seller.module": [
		"./src/app/courses/seller/course-seller.module.ts",
		"common",
		"course-seller.module"
	],
	"../webcam-assessments/webcam-assessments.module": [
		"./src/app/webcam-assessments/webcam-assessments.module.ts",
		"common",
		"webcam-assessments.module"
	],
	"./agora/agora.module": [
		"./src/app/agora/agora.module.ts"
	],
	"./amber/amber.module": [
		"./src/app/amber/amber.module.ts",
		"amber.module"
	],
	"./common/courses/courses.module": [
		"./src/app/common/courses/courses.module.ts",
		"common"
	],
	"./common/product-data/product-variants/components/details/product-variant-details-common.module": [
		"./src/app/common/product-data/product-variants/components/details/product-variant-details-common.module.ts",
		"product-variant-details-common.module"
	],
	"./common/product-data/products/components/bulk-edit/product-bulk-edit-common.module": [
		"./src/app/common/product-data/products/components/bulk-edit/product-bulk-edit-common.module.ts",
		"common",
		"product-bulk-edit-common.module"
	],
	"./common/product-data/products/components/details/product-details-common.module": [
		"./src/app/common/product-data/products/components/details/product-details-common.module.ts",
		"common",
		"product-details-common.module"
	],
	"./common/product-data/products/products-common.module": [
		"./src/app/common/product-data/products/products-common.module.ts",
		"common",
		"products-common.module"
	],
	"./common/reviews/reviews.module": [
		"./src/app/common/reviews/reviews.module.ts",
		"reviews.module"
	],
	"./courses/seller/course-seller.module": [
		"./src/app/courses/seller/course-seller.module.ts",
		"common",
		"course-seller.module"
	],
	"./dm/dm.module": [
		"./src/app/dm/dm.module.ts",
		"dm.module"
	],
	"./legal/legal.module": [
		"./src/app/legal/legal.module.ts",
		"legal.module"
	],
	"./library/platform/eden-platform.module": [
		"./src/app/library/platform/eden-platform.module.ts",
		"eden-platform.module"
	],
	"./library/seller/library.module": [
		"./src/app/library/seller/library.module.ts",
		"library.module"
	],
	"./lxp-config/lxp-config.module": [
		"./src/app/lxp-config/lxp-config.module.ts",
		"lxp-config.module"
	],
	"./new-product-seller/new-product-seller.module": [
		"./src/app/new-product-seller/new-product-seller.module.ts",
		"common",
		"new-product-seller.module"
	],
	"./notification-management/notification-management.module": [
		"./src/app/notification-management/notification-management.module.ts",
		"notification-management.module"
	],
	"./odyssey/transaction/transaction.module": [
		"./src/app/odyssey/transaction/transaction.module.ts",
		"common",
		"transaction.module"
	],
	"./odyssey/transactionBuyer/transaction.module": [
		"./src/app/odyssey/transactionBuyer/transaction.module.ts",
		"common",
		"transaction.module.0"
	],
	"./organization/organization.module": [
		"./src/app/organization/organization.module.ts"
	],
	"./payment/payment.module": [
		"./src/app/payment/payment.module.ts",
		"payment.module"
	],
	"./phoenix2/buyer/buyer.module": [
		"./src/app/phoenix2/buyer/buyer.module.ts",
		"buyer.module"
	],
	"./phoenix2/platform/platform.module": [
		"./src/app/phoenix2/platform/platform.module.ts",
		"platform.module"
	],
	"./phoenix2/register/register.module": [
		"./src/app/phoenix2/register/register.module.ts",
		"common",
		"register.module"
	],
	"./phoenix2/seller/seller.module": [
		"./src/app/phoenix2/seller/seller.module.ts",
		"seller.module"
	],
	"./platform-approvals/platform-approvals.module": [
		"./src/app/platform-approvals/platform-approvals.module.ts",
		"common",
		"platform-approvals.module"
	],
	"./pricing/pricing.module": [
		"./src/app/pricing/pricing.module.ts",
		"pricing.module"
	],
	"./promotions/promotions.module": [
		"./src/app/promotions/promotions.module.ts",
		"common",
		"promotions.module"
	],
	"./public/public.module": [
		"./src/app/public/public.module.ts",
		"public.module"
	],
	"./sm/sm.module": [
		"./src/app/sm/sm.module.ts",
		"sm.module"
	],
	"./solar/classes/classes.module": [
		"./src/app/solar/classes/classes.module.ts",
		"classes.module"
	],
	"./solar/courses/courses.module": [
		"./src/app/solar/courses/courses.module.ts",
		"common",
		"courses.module"
	],
	"./solar/scorm-cloud/scorm-cloud.module": [
		"./src/app/solar/scorm-cloud/scorm-cloud.module.ts",
		"scorm-cloud.module"
	],
	"./solar/seller-exam-fulfillment/seller-exam-fulfillment.module": [
		"./src/app/solar/seller-exam-fulfillment/seller-exam-fulfillment.module.ts",
		"seller-exam-fulfillment.module"
	],
	"./solar/voucher-management/voucher-management.module": [
		"./src/app/solar/voucher-management/voucher-management.module.ts",
		"voucher-management.module"
	],
	"./support/support.module": [
		"./src/app/support/support.module.ts",
		"support.module"
	],
	"./tm/platform/template.module": [
		"./src/app/tm/platform/template.module.ts",
		"template.module"
	],
	"./voucher/voucher.module": [
		"./src/app/voucher/voucher.module.ts",
		"voucher.module"
	],
	"./webcam-assessments/webcam-assessments.module": [
		"./src/app/webcam-assessments/webcam-assessments.module.ts",
		"common",
		"webcam-assessments.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_gendir lazy
// module id = ./src/$$_gendir lazy recursive
// module chunks = main